export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YNpoilss6yLUrwA.02694a99.woff2";